var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.rootClassName},[(_vm.shouldShowImage)?_c('img',{attrs:{"src":_vm.src,"data-qa":"userpic"},on:{"load":_vm.handleLoad,"error":_vm.handleError}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }